import { useState } from "react"

import { Check, ChevronRight, Image, Palette, Settings, Sparkles, Type } from "@/components/icons"
import { cn } from "@/lib/utils"

const STEPS = [
  { icon: Type, label: "Prompt", description: "Describe your image" },
  { icon: Image, label: "Format", description: "Size & quality" },
  { icon: Palette, label: "Style", description: "Visual style" },
  { icon: Settings, label: "Advanced", description: "Fine-tune" },
  { icon: Sparkles, label: "Generate", description: "Review & create" },
]

export function DemoImageWizardSteps() {
  const [activeStep, setActiveStep] = useState(0)

  return (
    <div className="bg-card w-full rounded-xl border p-4">
      <div className="flex items-center justify-between">
        {STEPS.map((step, idx) => {
          const isActive = idx === activeStep
          const isCompleted = idx < activeStep
          const Icon = step.icon

          return (
            <div key={step.label} className="flex items-center">
              <button
                className="flex flex-col items-center gap-1"
                type="button"
                onClick={() => setActiveStep(idx)}
              >
                <div
                  className={cn(
                    "flex h-10 w-10 items-center justify-center rounded-full border-2 transition-colors",
                    isActive && "border-primary bg-primary text-primary-foreground",
                    isCompleted && "border-foreground bg-success text-success-foreground",
                    !isActive && !isCompleted && "border-muted-foreground/30"
                  )}
                >
                  {isCompleted ? <Check className="h-4 w-4" /> : <Icon className="h-4 w-4" />}
                </div>
                <span
                  className={cn(
                    "text-xs font-medium",
                    isActive && "text-primary",
                    !isActive && "text-muted-foreground"
                  )}
                >
                  {step.label}
                </span>
              </button>
              {idx < STEPS.length - 1 && (
                <ChevronRight className="text-muted-foreground/30 mx-1 h-4 w-4 shrink-0" />
              )}
            </div>
          )
        })}
      </div>
      {/* Active step detail */}
      <div className="bg-muted/30 mt-4 rounded-lg p-4 text-center">
        <p className="text-sm font-semibold">{STEPS[activeStep].label}</p>
        <p className="text-muted-foreground text-xs">{STEPS[activeStep].description}</p>
      </div>
    </div>
  )
}
